<template>
	<row-object-page name="mail_action_edit" :oref="oref" v-model="mailAction"></row-object-page>
</template>

<script setup lang="ts">
import {ref, watch, computed} from "vue";
import RowObjectPage from "@/pages/row-object/RowObjectPage.vue";
import {objectRef, RowObjectInit, RowObjectRef, RowObjectType, SrcType} from "@t/meta/SourceType.ts";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import type {MailAction} from "@t/mail/MailAction.ts";
import {connectEventBus, injectEnv} from "@fd/Environment.ts";
import {useListStore, ListId} from "@/store/ListStore.ts";
import {useVirtualRoute} from "@/router/virtual/VirtualRouter.ts";
import {CREATE, EDIT, REPLACE_INIT_WITH_EDIT} from "@/pages/row-object/RowObjectEvents.ts";

const ns = useNavigationStore();
const env = injectEnv();
const ls = useListStore();
const bus = connectEventBus("MailActionPage");

const mailAction = ref<MailAction>(null);
const route = useVirtualRoute();
const oref = objectRef(route, SrcType.MAIL_ACTION);

ns.listenForStackerUpdates(bus, oref, () => env.msg('menu.editMailAction'),
	"/editMailAction.do", () => mailAction.value.name, () => mailAction.value.id);

watch(() => mailAction.value?.scope.account, (newAccount, oldAccount) => {
	if (oldAccount && oldAccount>0) { //skip first setting after load
		mailAction.value.scope.folder=0;
	}
	let listId = {
		serverId: "com.anneca.intouch.list.MailFoldersList[account="+mailAction.value.scope.account+"]",
		cacheId: "folderList",
		forceLoad: true
	};
    ls.findList(listId);
});
</script>

<style>
</style>